import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "error", "preview", "placeholder"]
  static values = {
    maxBytes: Number,
    min: Number,
    max: Number,
    typeError: String,
    sizeError: String,
    dimensionError: String
  }

  connect() {
    this.invalid = false
  }

  pick(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  validate() {
    const file = this.inputTarget.files[0]
    this.clearError()
    if (!file) return

    if (!["image/jpeg", "image/png"].includes(file.type)) {
      this.fail(this.typeErrorValue)
      return
    }

    if (file.size > this.maxBytesValue) {
      this.fail(this.sizeErrorValue)
      return
    }

    const url = URL.createObjectURL(file)
    const image = new Image()
    image.onload = () => {
      const tooSmall = image.width < this.minValue || image.height < this.minValue
      const tooLarge = image.width > this.maxValue || image.height > this.maxValue
      if (tooSmall || tooLarge) {
        this.fail(this.dimensionErrorValue)
        URL.revokeObjectURL(url)
        return
      }

      this.invalid = false
      if (this.hasPreviewTarget) {
        this.previewTarget.src = url
        this.previewTarget.classList.remove("d-none")
      }
      if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("d-none")
    }
    image.onerror = () => {
      this.fail(this.typeErrorValue)
      URL.revokeObjectURL(url)
    }
    image.src = url
  }

  guard(event) {
    if (this.invalid) event.preventDefault()
  }

  fail(message) {
    this.invalid = true
    this.inputTarget.value = ""
    this.errorTarget.hidden = false
    this.errorTarget.textContent = message
  }

  clearError() {
    this.invalid = false
    if (!this.hasErrorTarget) return

    this.errorTarget.hidden = true
    this.errorTarget.textContent = ""
  }
}
